angular.module('CarsSaraBo').factory('RangeDefinitionService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/rangedefinition/:oid', 
    { companyOid : '@companyOid', oid : '@oid' },
    {
    	get:    {method:'GET', isArray:true},
    	post : {method:'POST'},
    	update : { method: 'PUT' },
    	remove : { method: 'DELETE' }
    }
  )}
]);

angular.module('CarsSaraBo').factory('RangeDefinitionListService', ['$resource', function($resource) {
	  return $resource('../rest/company/:companyOid/rangedefinition/list', 
	    { companyOid : '@companyOid' },
	    {
	    	post : {method:'POST'},
	    	get:    {method:'GET', isArray:true}
	    }
	  )}
	]);




//////////////////
// WEBPACK FOOTER
// ./public/app/models/range_definition_service.js
// module id = 861
// module chunks = 3